/**
 * Format AI response text with beautiful HTML formatting
 * Linear-inspired text rendering
 */

export const formatResponse = (text) => {
  if (!text) return '';
  
  let formatted = text;
  
  // Convert **bold** to <strong>
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold text-slate-900">$1</strong>');
  
  // Convert numbered lists (1., 2., etc.)
  formatted = formatted.replace(/^(\d+)\.\s+(.+)$/gm, (match, num, content) => {
    return `<div class="flex gap-3 mb-3"><span class="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-sm font-semibold">${num}</span><span class="flex-1 text-slate-700 leading-relaxed">${content}</span></div>`;
  });
  
  // Convert bullet points (-, •, *)
  formatted = formatted.replace(/^[\-\•\*]\s+(.+)$/gm, (match, content) => {
    return `<div class="flex gap-3 mb-2"><span class="flex-shrink-0 w-1.5 h-1.5 bg-slate-400 rounded-full mt-2"></span><span class="flex-1 text-slate-700 leading-relaxed">${content}</span></div>`;
  });
  
  // Convert double line breaks to paragraphs
  formatted = formatted.split('\n\n').map(para => {
    if (para.includes('<div class="flex')) {
      return para; // Already formatted as list
    }
    return `<p class="text-slate-700 leading-relaxed mb-4">${para.trim()}</p>`;
  }).join('');
  
  // Single line breaks become <br>
  formatted = formatted.replace(/\n/g, '<br/>');
  
  // Highlight legal terms (optional)
  const legalTerms = [
    'arbeidsmiljøloven', 'avtaleloven', 'kjøpsloven', 'GDPR',
    'personopplysningsloven', 'rettigheter', 'forpliktelser',
    'oppsigelse', 'erstatning', 'avtale', 'kontrakt'
  ];
  
  legalTerms.forEach(term => {
    const regex = new RegExp(`\\b(${term})\\b`, 'gi');
    formatted = formatted.replace(regex, '<span class="font-medium text-blue-700">$1</span>');
  });
  
  return formatted;
};

export const formatChatMessage = (text) => {
  if (!text) return '';
  
  let formatted = text;
  
  // Bold text
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold">$1</strong>');
  
  // Code blocks (optional)
  formatted = formatted.replace(/`(.*?)`/g, '<code class="px-1.5 py-0.5 bg-slate-100 rounded text-xs font-mono">$1</code>');
  
  // Line breaks
  formatted = formatted.replace(/\n/g, '<br/>');
  
  return formatted;
};
